module.exports = __webpack_public_path__ + "static/media/logoIcon.4c599824.svg";